import React from "react";
import { Link } from "react-router-dom";
import LegalDocumentLayout from "./LegalDocumentLayout";

export default function ShippingPolicy() {
  return (
    <LegalDocumentLayout title="Shipping & delivery policy">
      <h2>Service geography</h2>
      <p>
        Delivery availability depends on the serviceable pin code and garment availability. Any delivery or pickup charge
        will be shown during checkout or confirmed by our team before the order is finalised.
      </p>

      <h2>Rental timelines</h2>
      <p>
        We aim to deliver rented garments before the agreed rental start date. Delivery estimates are not guarantees and
        may be affected by courier delays, weather, public holidays, incorrect addresses, or events outside our control.
        Please place time-sensitive orders early.
      </p>

      <h2>Liability during transit</h2>
      <p>
        Please inspect the package on delivery and notify us promptly about a missing, incorrect, or visibly damaged item.
        We will review the order and courier records and arrange an appropriate resolution where the issue is confirmed.
      </p>

      <h2>Returns & reverse logistics</h2>
      <p>
        Return or pickup instructions will be shared with the order. Garments and supplied accessories must be packed
        securely and returned by the agreed date. Late, lost, or damaged returns may affect the refundable deposit as
        described in our <Link to="/refund-policy">refund policy</Link>.
      </p>
    </LegalDocumentLayout>
  );
}
